(function(){
  var Q='.ctimer[data-ct-id]';
  function pad(n){return String(n).padStart(2,'0');}
  function bool(v){return String(v).toLowerCase()==='true';}
  function nowMs(){return Date.now();}
  function move(el,target,pos){
    if(!el||!target) return;
    if(pos==='before'){target.parentNode&&target.parentNode.insertBefore(el,target);return;}
    if(pos==='after'){target.parentNode&&target.parentNode.insertBefore(el,target.nextSibling);return;}
    if(pos==='prepend'){target.insertBefore(el,target.firstChild);return;}
    target.appendChild(el);
  }
  function norm(sel){
    if(!sel) return '';
    sel=sel.trim();
    sel=sel.replace(/#announcementbar\b/i,'.announcement-bar');
    sel=sel.replace(/^#announcement$/i,'.announcement-bar');
    sel=sel.replace(/^announcement(bar)?$/i,'.announcement-bar');
    sel=sel.replace(/^header$/i,'#SiteHeader');
    return sel;
  }
  function findTargets(raw){
    if(!raw) return [];
    var out=[];
    raw.split(',').map(norm).filter(Boolean).forEach(function(s){
      document.querySelectorAll(s).forEach(function(n){out.push(n);});
      if(!out.length&&s==='.announcement-bar'){
        document.querySelectorAll('#shopify-section-header .announcement-bar, .shopify-section--header .announcement-bar').forEach(function(n){out.push(n);});
      }
      if(!out.length&&s==='#SiteHeader'){
        var h=document.getElementById('SiteHeader'); if(h) out.push(h);
      }
    });
    return out;
  }
  function headerFallback(){
    var n=document.querySelector('#shopify-section-header, .shopify-section--header, [id^="shopify-section"][id*="header"]');
    return n?{node:n,pos:'prepend'}:null;
  }
  function isPlaced(el){
    var sel=el.getAttribute('data-ct-target-selector')||'';
    var pos=(el.getAttribute('data-ct-target-position')||'after').toLowerCase();
    var t=findTargets(sel)[0];
    if(!sel||!t) return true;
    if(pos==='before') return t.previousSibling===el||el.nextSibling===t;
    if(pos==='after') return t.nextSibling===el||el.previousSibling===t;
    if(pos==='prepend') return t.firstChild===el;
    if(pos==='append') return t.lastChild===el;
    return false;
  }
  function place(el,force){
    var sel=el.getAttribute('data-ct-target-selector')||'';
    var pos=(el.getAttribute('data-ct-target-position')||'after').toLowerCase();
    var t=findTargets(sel)[0];
    if(sel&&t){ move(el,t,pos); return true; }
    if(!sel||force){
      var fb=headerFallback();
      if(fb&&fb.node){ move(el,fb.node,fb.pos); return true; }
    }
    return false;
  }
  function setDHMS(el,ms){
    var dEl=el.querySelector('[data-ct-d]'),hEl=el.querySelector('[data-ct-h]'),mEl=el.querySelector('[data-ct-m]'),sEl=el.querySelector('[data-ct-s]');
    var ts=Math.max(0,Math.floor(ms/1000));
    var D=Math.floor(ts/86400),H=Math.floor((ts%86400)/3600),M=Math.floor((ts%3600)/60),S=ts%60;
    if(dEl)dEl.textContent=pad(D);
    if(hEl)hEl.textContent=pad(H);
    if(mEl)mEl.textContent=pad(M);
    if(sEl)sEl.textContent=pad(S);
  }
  function initTimer(el){
    var mode=(el.dataset.ctMode||'cycle').toLowerCase();
    var loop=bool(el.dataset.ctLoop);
    var hide=bool(el.dataset.ctHideOnEnd);
    var days=+el.dataset.ctDays||0;
    var hours=+el.dataset.ctHours||0;
    var minutes=+el.dataset.ctMinutes||0;
    var seconds=+el.dataset.ctSeconds||0;
    var duration=(((days*24+hours)*60+minutes)*60+seconds)*1000;

    var skew=0;
    if(el.dataset.ctNow){
      var serverNow=Date.parse(el.dataset.ctNow);
      if(!isNaN(serverNow)) skew=serverNow-nowMs();
    }
    function nowAdj(){return nowMs()+skew;}

    if(mode==='absolute'){
      var endIso=(el.dataset.ctEndIso||'').trim();
      var endA=Date.parse(endIso);
      if(isNaN(endA)){ el.classList.add('ctimer--hidden'); return; }
      var ida;
      function tickA(){
        var left=endA-nowAdj();
        setDHMS(el,left);
        if(left<=0){
          if(loop&&duration>0){ endA=endA+duration; }
          else { if(hide) el.classList.add('ctimer--hidden'); clearInterval(ida); if(!hide) setDHMS(el,0); }
        }
      }
      tickA(); ida=setInterval(tickA,1000); return;
    }

    if(!duration){ el.classList.add('ctimer--hidden'); return; }

    if(mode==='cycle'){
      var d=duration;
      var t=nowAdj();
      var k=Math.floor(t/d);
      var endC=(k+1)*d;
      var idc;
      function tickC(){
        var left=endC-nowAdj();
        setDHMS(el,left);
        if(left<=0){
          if(loop){ endC=endC+d; }
          else {
            if(hide) el.classList.add('ctimer--hidden');
            clearInterval(idc);
            if(!hide) setDHMS(el,0);
          }
        }
      }
      tickC(); idc=setInterval(tickC,1000); return;
    }

    var idr;
    var keyR='ctimer:end:'+el.dataset.ctId;
    var endR=loop?(nowAdj()+duration):Number(localStorage.getItem(keyR));
    if(!endR||isNaN(endR)||endR<=nowAdj()){
      endR=nowAdj()+duration;
      if(!loop) try{ localStorage.setItem(keyR,String(endR)); }catch(e){}
    }
    function tickR(){
      var left=endR-nowAdj();
      setDHMS(el,left);
      if(left<=0){
        if(loop){ endR=nowAdj()+duration; }
        else {
          if(hide) el.classList.add('ctimer--hidden');
          clearInterval(idr);
          if(!hide) setDHMS(el,0);
        }
      }
    }
    tickR(); idr=setInterval(tickR,1000);
  }
  function boot(){
    document.querySelectorAll(Q).forEach(function(el){
      place(el,true);
      initTimer(el);
    });
    var tries=0;
    var tid=setInterval(function(){
      document.querySelectorAll(Q).forEach(function(el){
        if(!isPlaced(el)) place(el,false);
      });
      if(++tries>40) clearInterval(tid);
    },150);
    var mo=new MutationObserver(function(){
      document.querySelectorAll(Q).forEach(function(el){
        if(!isPlaced(el)) place(el,false);
      });
    });
    mo.observe(document.documentElement,{childList:true,subtree:true});
    setTimeout(function(){mo.disconnect();},15000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function(){
    document.querySelectorAll(Q).forEach(function(el){ if(!isPlaced(el)) place(el,false); });
  });
})();
